export const LOADING_DOCUMENT_LIST = "LOADING_DOCUMENT_LIST";
export const SUCCESS_DOCUMENT_LIST = "SUCCESS_DOCUMENT_LIST";
